module.exports = __webpack_public_path__ + "media/images/badge/ninja_secondary-19020c1e4aaf83980089fb00c96720a8.png";